import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import { Button } from 'react-bootstrap';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  AttendanceDatatable = (props) => {

    const [t] = useTranslation();        
    const [checkTime, setCheckTime] = useState(null);
    const [omitLockButton, setOmitLockButton] = useState(true);
    const tableName = t('attendance.label.attendanceList'); 


    const clickHandler = (row) => {
        //row.target.id      
        //   props.parentCallback(row.target.id);  
           
           RestService.callAnyApi('attendance/setAttendanceCheck?id='+row.target.id, null)
           .then((data) => {
            setCheckTime(Date.now());
           })
           .catch((error) => {
             console.log(error);
           });

     };

    const getLockButton = () => {
        return (
            props.user.accessRights && props.user.accessRights.rightsEntityAttendanceAdmin === 1 ? false : true
        );
    } 

    const removeZeroValues  = (value) => {

     
      if(value==='00:00' || value===0){value='';}

      return (
        <>
        {value}
        </>
      );
    }

    const columns = [       
        { name: "Id", data: "id", selector: "id", omit: true},
        { name: t('user.label.personalNumber'), data: "user.personalNumber", sortable: true, selector: "user.personalNumber"},    		      
        { name: t('user.label.firstName'), data: "user.address.firstName",  sortable: true,  selector: "user.address.firstName"} ,            
        { name: t('user.label.lastName'), data: "user.address.lastName",  sortable: true,  selector: "user.address.lastName"} ,       
        { name: t('attendance.label.month'), data: "month",  sortable: true,  selector: "month"},       
        { name: t('attendance.label.sumWork'),  sortable: false, selector: "sumWorkText", cell:(row) => removeZeroValues(row.sumWorkText) },
        { name: t('attendance.label.sumLunch'), sortable: false, selector: "sumLunchText", cell:(row) => removeZeroValues(row.sumLunchText) },
        { name: t('attendance.label.sumDoctor'), sortable: false, selector: "sumDoctorText", cell:(row) => removeZeroValues(row.sumDoctorText) },
        { name: t('attendance.label.sumDoctorWithFamily'), sortable: false, selector: "sumDoctorWithFamilyText", cell:(row) => removeZeroValues(row.sumDoctorWithFamilyText) },
        { name: t('attendance.label.sumHoliday'),  sortable: false, selector: "sumHolidayText", cell:(row) => removeZeroValues(row.sumHolidayText) },
        { name: t('attendance.label.sumBusinessTrip'), sortable: false, selector: "sumBusinessTripText", cell:(row) => removeZeroValues(row.sumBusinessTripText) },
        { name: t('attendance.label.sumOther'),  sortable: false,  selector: "sumOtherText", cell:(row) => removeZeroValues(row.sumOtherText) },       
        { name: t('attendance.label.saldo'), sortable: true,  selector: "saldoText", cell:(row) => removeZeroValues(row.saldoText)},
        { name: t('attendance.label.saldoDiff'),  sortable: false, selector: "saldoDiffText", cell:(row) => removeZeroValues(row.saldoDiffText)},      
        { name: t('attendance.label.mealTicket'),  sortable: false, selector: "mealTicket", cell:(row) => removeZeroValues(row.mealTicket)},
        { name: t('attendance.label.lock'),  sortable: false, selector: "lock",
            cell:(row) => row.lock===1 ? <i class="fa fa-lock" style={{color: '#ff0000'}} aria-hidden="true"></i> : <i class="fa fa-unlock" style={{color: '#009933'}} aria-hidden="true"></i>

        },
        { name: t('attendance.label.checkedBy'),  sortable: false, selector: "checkedUser.address.lastName"},
        { name: t('attendance.label.checkTime'),  sortable: false, selector: "checkTimeText"},
        { name: t('general.button.lock'), cell:(row) => row.id ? <Button className="btn-default"  onClick={clickHandler} id={row.id} name={row.name} >{row.lock===0 ? t('general.button.lock') : t('general.button.unlock')}</Button> : "" ,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        omit: getLockButton()
        
     }          
     
    ];        


    const columnsData = [       
     //   { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('user.label.personalNumber'), data: "user.personalNumber",  orderable: true, searchable: true, search: {value: '',regex: false}},    		     
        { name: t('user.label.firstName'), data: "user.address.firstName", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('user.label.lastName'), data: "user.address.lastName", orderable: true,  searchable: true, search: {value: '',regex: false}},            
        { name: t('attendance.label.month'), data: "month", orderable: true,  searchable: true, search: {value: '',regex: false}},        
        { name: t('attendance.label.sumWork'), data: "sumWorkText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumLunch'), data: "sumLunchText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumDoctor'), data: "sumDoctorText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumDoctorWithFamily'), data: "sumDoctorWithFamilyText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumHoliday'), data: "sumHolidayText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumBusinessTrip'), data: "sumBusinessTripText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumOther'), data: "sumOtherText", searchable: false, orderable: false, search: {value: '',regex: false}},
       // { name: t('attendance.label.sumAll'), data: "sumAllText", searchable: false, orderable: false, search: {value: '',regex: false}},  
        { name: t('attendance.label.saldo'), data: "saldoText", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.saldoDiff'), data: "saldoDiffText", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.mealTicket'), data: "mealTicket", searchable: false, orderable: false, search: {value: '',regex: false}},            
        { name: t('attendance.label.lock'), data: "lock", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.checkedBy'), data: "checkedUser.address.lastName", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.checkTime'), data: "checkTimeText", searchable: false, orderable: false, search: {value: '',regex: false}}
          
    ];    
            
     const url = RestService.getBaseURL()+"attendance/getAttendanceList";   
     const urlExcel = RestService.getBaseURL()+"attendance/getExcelAttendance";          
    
   
 
   

      useEffect(() => {      
        setCheckTime(props.checkTime);
      }, [props.checkTime])


     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
                 checkTime={checkTime}
             />
           
         );
    
 
  
 };

 const mapStateToProps = (state) => ({
    user: state.auth.currentUser
  });
  

export default connect(mapStateToProps, null)(AttendanceDatatable);

